import { defineComponent, h, inject } from 'vue'
import { interfaceNames, interfaceRegistryKey } from '../lib/interfaceRegistry.js'

export default defineComponent({
  name: 'InterfaceSlot',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true, validator: name => interfaceNames.includes(name) },
  },
  setup(props, { attrs, slots }) {
    const registry = inject(interfaceRegistryKey, {})

    return () => {
      const component = registry[props.name]

      return component ? h(component, attrs, slots) : slots.default?.()
    }
  },
})
